export default "__VITE_ASSET__DCerwt_C__"